<template>
    <svg class="quiz-icon" width="24" height="24"><use :href="`#icon_${slug}`"></use></svg>
</template>

<script>
export default {
    props: {
        // see resources/views/layouts/partials/svg-sprites.blade.php
        slug: {
            type: String,
            default: "",
            required: true
        }
    },
    name: "QuizIcon"
}
</script>

<style lang="scss" scoped>
.quiz-icon {
    min-width: 24px;
    height: 24px;
}
</style>
